/**
 * Periapical Lesion — radiolucent halo at the apex of each root canal. Drawn
 * with a soft dark radial gradient to communicate bone loss around the apex.
 */
import { rootCanals, uid } from "./_shared";

export default function PeriapicalLesion({ type = "incisor", toothId }) {
  const canals = rootCanals(type);
  const gid = uid("periap", toothId);

  return (
    <g style={{ pointerEvents: "none" }}>
      <defs>
        <radialGradient id={gid} cx="50%" cy="50%" r="50%">
          <stop offset="0%"   stopColor="#1B1F25" stopOpacity="0.75" />
          <stop offset="55%"  stopColor="#4A5260" stopOpacity="0.45" />
          <stop offset="100%" stopColor="#8892A0" stopOpacity="0" />
        </radialGradient>
      </defs>

      {canals.map((c, i) => (
        <g key={i}>
          {/* Diffuse radiolucent halo */}
          <circle cx={c.tip[0]} cy={c.tip[1]} r={7}
                  fill={`url(#${gid})`} />
          {/* Sharper inner border */}
          <circle cx={c.tip[0]} cy={c.tip[1]} r={3.6}
                  fill="none" stroke="#1B1F25"
                  strokeOpacity={0.55} strokeWidth={0.6} />
        </g>
      ))}
    </g>
  );
}
